// Modified from https://github.com/mourner/tinyqueue/blob/master/index.js
// License: https://github.com/mourner/tinyqueue/blob/master/LICENSE

/**
 * Implements a priority queue
 * 
 * @export {function}
 * @param {Array} data Data to load into the queue
 * @param {function} compare Function to compare the data
 */
export default function TinyQueue(data, compare) {
    if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);

    this.data = data || [];
    this.length = this.data.length;
    this.compare = compare || defaultCompare;

    if (this.length > 0) {
        for (var i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
    }
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

TinyQueue.prototype = {

    push: function (item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    },

    pop: function () {
        if (this.length === 0) return undefined;

        var top = this.data[0];
        this.length--;

        if (this.length > 0) {
            this.data[0] = this.data[this.length];
            this._down(0);
        }
        this.data.pop();

        return top;
    },

    remove: function(node) {
        var index = this.data.indexOf(node);

        if (index > -1) {
            this.length--;

            if (this.length > 0) {
                this.data[index] = this.data[this.length];
                this._down(index);
            }

            var removed = this.data.splice(-1, 1);

            return removed;
        } else {
            return undefined;
        }
    },

    peek: function () {
        return this.data[0];
    },

    _up: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var item = data[pos];

        while (pos > 0) {
            var parent = (pos - 1) >> 1;
            var current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    },

    _down: function (pos) {
        var data = this.data;
        var compare = this.compare;
        var halfLength = this.length >> 1;
        var item = data[pos];

        while (pos < halfLength) {
            var left = (pos << 1) + 1;
            var right = left + 1;
            var best = data[left];

            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;

            data[pos] = best;
            pos = left;
        }

        data[pos] = item;
    },

    getData: function () {
        return this.data;
    }
};


// WEBPACK FOOTER //
// ./src/utilities/TinyQueue.js